import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FiMenu, FiX } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { getRandomWhatsappNumber } from '../../utils';
import Modal from '../../components/sections/TestimonialsSection/Modal';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const nomeRef = React.useRef<HTMLInputElement>(null);
  const telefoneRef = React.useRef<HTMLInputElement>(null);
  const emailRef = React.useRef<HTMLInputElement>(null);
  const [telefoneFormatado, setTelefoneFormatado] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [erroCampos, setErroCampos] = useState<{nome: boolean, telefone: boolean, email: boolean}>({nome: false, telefone: false, email: false});
  const [mensagemErro, setMensagemErro] = useState('');

  const WORKER_API_URL = process.env.REACT_APP_WORKER_API_URL || '';
  // console.log(WORKER_API_URL);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setWhatsappNumber(getRandomWhatsappNumber());
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navLinks = [
    { id: 'como-funciona', label: 'Como Funciona' },
    { id: 'case-sucesso', label: 'Depoimentos' },
    { id: 'depoimentos', label: 'Simulador' },
    { id: 'faq', label: 'FAQ' },
  ];

  function aplicarMascaraTelefone(valor: string) {
    valor = valor.replace(/\D/g, '');
    valor = valor.slice(0, 11);
    if (valor.length > 6) {
      return `(${valor.slice(0, 2)}) ${valor.slice(2, 7)}-${valor.slice(7)}`;
    } else if (valor.length > 2) {
      return `(${valor.slice(0, 2)}) ${valor.slice(2)}`;
    } else if (valor.length > 0) {
      return `(${valor}`;
    }
    return '';
  }
  function validarEmail(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  function validarTelefone(telefone: string) {
    return /^\(?\d{2}\)?[\s-]?\d{4,5}-?\d{4}$/.test(telefone.replace(/\D/g, ''));
  }
  const handleTelefoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const valor = e.target.value;
    setTelefoneFormatado(aplicarMascaraTelefone(valor));
  };
  const enviarLeadParaWorker = async () => {
    const nome = nomeRef.current?.value.trim() || '';
    const telefone = telefoneFormatado.trim() || '';
    const email = emailRef.current?.value.trim() || '';
    const telefoneLimpo = telefone.replace(/\D/g, '');
    const emailValido = validarEmail(email);
    const telefoneValido = validarTelefone(telefoneLimpo);
    const nomeValido = nome.length > 1;
    setErroCampos({ nome: !nomeValido, telefone: !telefoneValido, email: !emailValido });
    if (!nomeValido || !telefoneValido || !emailValido) {
      setMensagemErro('dados incompletos');
      return false;
    }
    setMensagemErro('');
    const timestamp = new Date().toISOString();
    await fetch(WORKER_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        nome,
        numero: telefoneLimpo,
        email,
        timestamp,
        atendente: whatsappNumber
      }),
    });
    return true;
  };

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-white shadow-soft py-2' 
          : 'bg-gradient-to-r from-primary-dark via-primary-dark to-primary py-5 shadow-xl border-b border-secondary/20'
      }`}
    >
      {/* Efeito de brilho sutil */}
      {!scrolled && (
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-10 left-1/4 w-64 h-24 bg-secondary/10 blur-3xl rounded-full"></div>
          <div className="absolute -bottom-8 right-1/3 w-72 h-16 bg-secondary/5 blur-3xl rounded-full"></div>
        </div>
      )}
      
      <div className="container mx-auto flex justify-between items-center px-4 relative z-10">
        <div className="flex items-center flex-1">
          <div className={`text-2xl font-bold ${scrolled ? 'text-primary' : 'text-white'}`}>RTL Energia</div>
        </div>
        {/* Centraliza todos os nav links */}
        <nav className="hidden md:flex items-center justify-center flex-1 space-x-8 text-center">
          {navLinks.map((link) => (
            <Link
              key={link.id}
              to={link.id}
              spy={true}
              smooth={true}
              offset={-80}
              duration={0}
              className={`${scrolled ? 'text-primary' : 'text-white'} hover:text-secondary font-medium cursor-pointer transition-colors`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        {/* Deixa só o botão Fale Conosco na ponta direita */}
        {/* <div className="hidden md:flex items-center flex-1 justify-end">
          <a
            href="#hero"
            className="btn btn-primary flex items-center"
          >
            <FaWhatsapp className="mr-2" />
            Fale Conosco
          </a>
        </div> */}

        {/* Mobile Navigation Toggle */}
        <button
          className={`md:hidden ${scrolled ? 'text-primary' : 'text-white'} p-2`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          {isMenuOpen ? (
            <FiX className="w-6 h-6" />
          ) : (
            <FiMenu className="w-6 h-6" />
          )}
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-gradient-to-b from-primary-dark to-primary-dark/95 absolute top-full left-0 right-0 shadow-xl animate-fade-in border-t border-secondary/20">
          <div className="container mx-auto py-4 px-4">
            <div className="flex flex-col space-y-4 items-center text-center">
              {navLinks.map((link) => (
                <Link
                  key={link.id}
                  to={link.id}
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={0}
                  className="text-white hover:text-secondary font-medium py-2 cursor-pointer transition-colors"
                  onClick={closeMenu}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="#hero"
                className="btn btn-primary mt-2 flex items-center"
                onClick={closeMenu}
              >
                <FaWhatsapp className="mr-2" />
                Fale Conosco
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Modal Fale Conosco */}
      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <div className="flex flex-col items-center">
          <h3 className="text-2xl font-bold text-yellow-900 mb-2 text-center">Fale Conosco</h3>
          <form className="w-full space-y-3 mb-3">
            <input
              type="text"
              placeholder="Seu nome"
              ref={nomeRef}
              className={`w-full px-4 py-3 border border-gray-200 rounded-lg bg-white focus:ring-2 focus:ring-yellow-300 focus:border-yellow-400 transition ${erroCampos.nome ? 'border-red-500' : ''}`}
            />
            <input
              type="tel"
              placeholder="Seu telefone"
              ref={telefoneRef}
              value={telefoneFormatado}
              onChange={handleTelefoneChange}
              className={`w-full px-4 py-3 border border-gray-200 rounded-lg bg-white focus:ring-2 focus:ring-yellow-300 focus:border-yellow-400 transition ${erroCampos.telefone ? 'border-red-500' : ''}`}
            />
            <input
              type="email"
              placeholder="Seu e-mail"
              ref={emailRef}
              className={`w-full px-4 py-3 border border-gray-200 rounded-lg bg-white focus:ring-2 focus:ring-yellow-300 focus:border-yellow-400 transition ${erroCampos.email ? 'border-red-500' : ''}`}
            />
            {mensagemErro && (
              <div className="text-red-600 text-center font-semibold">{mensagemErro}</div>
            )}
          </form>
          <a
            href={`https://wa.me/55${whatsappNumber}?text=${encodeURIComponent(nomeRef.current?.value ? `Olá! Me chamo ${nomeRef.current.value} e quero conhecer a RTL Energia para saber como economizar na minha conta de luz!` : 'Quero conhecer a RTL Energia e saber como economizar na minha conta de luz!')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full py-3 flex items-center justify-center rounded-lg bg-yellow-400 text-yellow-900 font-bold hover:bg-yellow-300 transition shadow-md border border-yellow-300 mb-2"
            onClick={async (e) => {
              const nome = nomeRef.current?.value.trim() || '';
              const telefone = telefoneFormatado.trim() || '';
              const email = emailRef.current?.value.trim() || '';
              const telefoneLimpo = telefone.replace(/\D/g, '');
              const emailValido = validarEmail(email);
              const telefoneValido = validarTelefone(telefoneLimpo);
              const nomeValido = nome.length > 1;
              if (!nomeValido || !telefoneValido || !emailValido) {
                e.preventDefault();
                setErroCampos({ nome: !nomeValido, telefone: !telefoneValido, email: !emailValido });
                setMensagemErro('dados incompletos');
                return;
              }
              setMensagemErro('');
              await enviarLeadParaWorker();
            }}
          >
            <FaWhatsapp className="mr-2" /> Fale conosco
          </a>
        </div>
      </Modal>
    </header>
  );
};

export default Header; 